<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <h2
          >Bem vindo (a), <span class="text-info">{{ usuario.nome }}</span
          >.</h2
        >
        <h4><strong>Último login</strong>: {{ ultimoLogin }} </h4>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="panel panel-primary">
          <div class="panel-heading">Avisos</div>
          <div class="panel-body"> Nenhum aviso. </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { useMenu } from '@/composables/useMenu'
import appStore from '@/stores'

const menuAtual = { descricao: 'Home', breadcrumb: ['Home'] }

export default {
  name: 'Home',
  setup() {
    useMenu(menuAtual)
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
    ultimoLogin() {
      return moment(this.usuario.ultimoLogin).format(
        'dddd, D MMMM. YYYY. HH:mm'
      )
    },
  },
}
</script>
